import service from "@/store/services/pdf-service";
import axios from "axios";

const state = {
  me: null,
};

const mutations = {
  SET_RESOURCE: (state, me) => {
    state.me = me;
  },
};

const actions = {
  download({ commit, dispatch }, params) {
    let currentSession = localStorage.getItem(
      "vue-authenticate.vueauth_access_token"
    );
    if (currentSession) {
      params.session_id = currentSession;

      return service
        .downloadPDF(params, params.type)
        .then((res) => {
          if (res.hasOwnProperty("data") && res.data.error) {
            commit("SET_ERROR_BIT", true, { root: true });
            commit(
              "SET_ERROR_INFO",
              "<br>" +
                "Server responded with error = True <br> errorCode: " +
                res.data.errorCode,
              { root: true }
            );
          }
          if (
            !res.data.error
          ) {
            return res.data;
            // this.$app.$store.dispatch("alerts/success", "Successfully Saved.");
          } else {
            this.$app.$store.dispatch(
              "alerts/error",
              "Oops, something went wrong"
            );
          }
        })
        .catch((err) => {
          commit("SET_ERROR_BIT", true, { root: true });
          commit("SET_ERROR_INFO", err.stack, { root: true });
        });
    }
  },
};

const getters = {
  me: (state) => state.me,
};

const pdf = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default pdf;
